// FNP-1192 — labels and paths every navigate/link in the module references, so
// a route rename is one edit rather than a grep.
//
// ⚠️ THE PATH IS A FUNCTION, NOT A CONSTANT, and that is the shape of the whole
// module: a record has NO identity outside its zone. There is no `/dns-records`
// index to link to — the only address a record list has is inside one zone,
// which is why FNP-1186 registered `zones/:zoneId/records` rather than a
// top-level route.
export default {
    entityKey: 'dns-records',
    // The parent zone's base path. Records nest under it.
    zonesBasePath: '/zones',
    // ⚠️ `connectionId` RIDES ALONG IN THE QUERY STRING, because
    // `listDnsRecords(connectionId: ID!, zoneId: ID!)` needs both and the route
    // carries only the zone id. The same resolution the zones detail page uses.
    recordsPath: (zoneId: string, connectionId?: string): string => {
        const base = `/zones/${encodeURIComponent(zoneId)}/records`;
        return connectionId
            ? `${base}?connectionId=${encodeURIComponent(connectionId)}`
            : base;
    },
    zonePath: (zoneId: string, connectionId?: string): string => {
        const base = `/zones/${encodeURIComponent(zoneId)}`;
        return connectionId
            ? `${base}?connectionId=${encodeURIComponent(connectionId)}`
            : base;
    },
    titles: {
        singular: 'Record',
        plural: 'Records',
    },
};
